export default __webpack_public_path__ + "static/media/follow.92bf39ba.png";